import Stores from './Stores';
export default Stores;